// Fase 1.7 do plano .ai/messenger-integration-plan.md: nunca renderizar um
// token/credencial completo em claro na tela — mostra só os 4 primeiros e 4
// últimos caracteres, com pontos fixos no meio (não escala com o tamanho do
// token, pra não vazar o comprimento real da credencial).
export function maskToken(token) {
  if (!token) return 'N/A';
  if (token.length <= 8) return '••••••••';

  return `${token.slice(0, 4)}${'•'.repeat(8)}${token.slice(-4)}`;
}
